import { desktopElectionPageAdsBuilder } from "./desktopElectionPageAdsBuilder";
import { mobileElectionPageAdsBuilder } from "./mobileElectionPageAdsBuilder";
import { deviceUtil, pageUtil } from "@repo/lib-common";
import { DomainPageClient } from "@repo/lib-domain-tag";
const PageTypeEnum = pageUtil.PageTypeEnum;
let isPageClientInitiated = false;
export const initElectionPageClient_Page = function () {
    if (isPageClientInitiated) return;
    isPageClientInitiated = true;
    const device = new deviceUtil.DeviceTypeInfo();
    const pageClient = new DomainPageClient();
    pageClient.device = device;
    pageClient.pageType = PageTypeEnum.election;


    if (device.isMobile()) {
        pageClient.adsBuilder = mobileElectionPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForMobile);
    } else {
        pageClient.adsBuilder = desktopElectionPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForDesktop);
    }

    window.domainClient = pageClient;
    const isLoggedIn = pageClient.doesCookieExists('loggedIn');
    pageClient.adsBuilder.setIsEnabled(!isLoggedIn);
    pageClient.adsBuilder.execute();
}
initElectionPageClient_Page();
